import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Store-side swipeable/clickable image carousel. */
export default function ImageCarousel({ images = [], alt = "", className = "", testid = "carousel", onOpen }) {
  const list = images.length ? images : [""];
  const [i, setI] = useState(0);
  const touch = useRef(null);
  const go = (d, e) => { e?.stopPropagation(); setI((v) => (v + d + list.length) % list.length); };
  const onTouchStart = (e) => { touch.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => { if (touch.current == null) return; const dx = e.changedTouches[0].clientX - touch.current; if (Math.abs(dx) > 30) go(dx < 0 ? 1 : -1); touch.current = null; };
  return (
    <div data-testid={testid} className={`relative shrink-0 overflow-hidden rounded-xl bg-white ${className}`} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <img src={list[i]} alt={alt} data-testid={`${testid}-img`} onClick={() => onOpen && onOpen(list, i)} className={`h-full w-full object-contain ${onOpen ? "cursor-zoom-in" : ""}`} draggable={false} />
      {list.length > 1 && (<>
        <button type="button" data-testid={`${testid}-prev`} onClick={(e) => go(-1, e)} className="absolute left-0 top-1/2 -translate-y-1/2 rounded-r bg-black/40 p-0.5 text-white"><ChevronLeft className="h-3.5 w-3.5" /></button>
        <button type="button" data-testid={`${testid}-next`} onClick={(e) => go(1, e)} className="absolute right-0 top-1/2 -translate-y-1/2 rounded-l bg-black/40 p-0.5 text-white"><ChevronRight className="h-3.5 w-3.5" /></button>
        <div className="absolute inset-x-0 bottom-0.5 flex justify-center gap-0.5">{list.map((_, j) => <span key={j} className={`h-1 w-1 rounded-full ${j === i ? "bg-[#D46117]" : "bg-black/30"}`} />)}</div>
      </>)}
    </div>
  );
}
